module.exports = __webpack_public_path__ + "img/Weapon_157.c34ab7e9.png";